import type { IChangeInvocation } from '@utils/managers/ChangeRuntime';
import { errorText } from '@srm/core/errors';

const CHANGE_FAILURE_TEXT = 'Не удалось выполнить изменения по полю.';

/**
 * Вызов изнутри чужого каскада (цель invokeChanges): ChangeRuntime.invoke кладёт ключ цели
 * в activeTargets до вызова обработчика. Такой вызов ошибку не показывает, а пробрасывает —
 * каскад-источник обрывается, а не продолжает setValues на частично обновлённом состоянии.
 */
export const isNestedChangeInvocation = (invocation: IChangeInvocation | undefined) =>
    !!invocation && invocation.activeTargets.size > 0;

/**
 * Окно, в котором одинаковый текст отказа повторно не показывается: N полей с одним сломанным
 * callAction падают почти одновременно (вход в правку, монтирование формы строки).
 */
export const CHANGE_ERROR_DEDUPE_MS = 2000;
const shownAt = new Map<string, number>();

/** Показать отказ каскада в корне вызова. */
export function reportChangeError(
    error: unknown,
    setError: ((errors?: string[]) => void) | undefined,
    fallback = CHANGE_FAILURE_TEXT,
) {
    const text = errorText(error, fallback);
    const now = Date.now();
    for (const [shown, time] of shownAt) {
        if (now - time >= CHANGE_ERROR_DEDUPE_MS) shownAt.delete(shown);
    }
    if (shownAt.has(text)) return;
    shownAt.set(text, now);
    setError?.([text]);
}
